import { generateLabelAndValuesVariant, generateLabelsAndValues, generateTypeOfCPDLabelsAndValues } from "../utils/helperFunctions";

export const TypeOfCPD = {
    FORMAL_EDUCATION: 1,
    INFORMAL_EDUCATION: 2,
    CONGRESS_CONFERENCE_SEMINAR_SYMPOSIUM: 3,
    FELLOWSHIPS_ATTACHMENT_STUDY_TOUR: 4,
    COMMITTEE_PROJECT_MEMBER: 5,
    TECHNOLOGY_AND_TECHNICAL_RELATED_MEETING: 6,
    TECHNICAL_PAPER_PRESENTATION_AT_OFFICAL_FUNCTION_SEMINAR_MEETINGS: 7,
    PUBLICATION_OF_ARTICLES_IN_JOURNAL_CHAPTERS_IN_BOOK_TECHNICAL_REPORTS: 8,
    APPOINTED_AS_MBOT: 9,
    PROFESSIONAL_ASSESSOR_PANEL: 10,
    ACCREDITATION_ASSESSOR_PANEL: 11,
    ACCREDITATION_VISITS: 12,
    CONTRIBUTION_FOR_TECHNOLOGY_AND_TECHNICAL_ASPECTS_DEVELOPMENT: 13,
    ONLINE_PLATFORM_RELATED_TO_TECHNOLOGY_AND_TECHNICAL: 14,
    MENTORING_COACHING_JUDGES_CONSULTATION_RELATED_TO_PROFESSION: 15,
    HANDS_ON_SPECIAL_PROJECT_AND_RND_ACTIVITIES_RELATED_IN_TECHNOLOGY_AND_TECHNICAL: 16,
    CSR_PROGRAMME_AND_RELEVENT_VOLUNTARY_WORK: 17,
    SOFT_SKILLS_RELATED_TO_LEADERSHIP_AND_MANAGEMENT_INTERPERSONAL_SKILLS_AND_PROFESSIONAL_CONDUCT: 18,
};

export const TypeOfCPDActivities = generateTypeOfCPDLabelsAndValues(TypeOfCPD);

export const OrgTypeNames = [
    "Company registered or incorporated under Suruhanjaya Syarikat Malaysia (SSM)",
    "Association/ NGO",
    "Industry-based Training Centre",
    "Cooperatives registered under Suruhanjaya Koperasi Malaysia",
    "Government/ Semi-Government Institution",
];

export const orgEnum = {
    COMPANY_SSM: 1,
    ASSOCIATION_NGO: 2,
    INDUSTRY_BASED_TRAINING_CENTRE: 3,
    COOPERATIVES_KOPERASI: 4,
    GOVERNMENT_SEMI_GOVERNMENT_INSTITUTION: 5,
};

export const OrgTypeLabelAndValues = generateLabelAndValuesVariant({
    enums: orgEnum,
    labels: OrgTypeNames,
});

export const CPD_STATUS = {
    PENDING: 1,
    APPROVED: 2,
    REJECTED: 3,
};

export const findTypeOfCpd = (type) => {
    const data = TypeOfCPDActivities?.find((cpd) => cpd?.value === type);
    return data?.label;
};

export const findDurationType = (duration) => {
    if (duration === 1) return "Hours";
    else if (duration === 2) return "Days";
};

export const AtpSortConstants = [
    {
        label: "Date: Newest first",
        value1: "created_at",
        value2: "DESC",
    },
    {
        label: "Date: Oldest first",
        value1: "created_at",
        value2: "ASC",
    },
    {
        label: "Approved CPD hours: Highest first",
        value1: "awarded_cpd",
        value2: "DESC",
    },
    {
        label: "Approved CPD hours: Lowest first",
        value1: "awarded_cpd",
        value2: "ASC",
    },
    {
        label: "Approval Date: Newest first",
        value1: "approval_date",
        value2: "DESC",
    },
    {
        label: "Approval Date: Oldest first",
        value1: "approval_date",
        value2: "ASC",
    },
];

export const createCPDInitialValues = {
    title: "",
    location: "",
    duration_time: "",
    // date_time: null,
    start_date_time: null,
    end_date_time: null,
    tech_field: [],
    files: [],
    type_of_cpd: "",
    // web_url: "",
    description: "",
    duration_type: 2,
    target_audience: "",
    attachment: [],
    organization: "",
    approval_date: null,
};
